import script from "./MusicPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicPlay.vue?vue&type=script&setup=true&lang=js"

import "./MusicPlay.vue?vue&type=style&index=0&id=30898b2c&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30898b2c"]])

export default __exports__